<template>
  <v-layout v-if="editable" row wrap>
    <v-flex xs12 sm4 md4>
      <v-select
        v-model="colaborator_hours.acceso"
        :label=dia
        :items="tipo_dia_acceso"
      />
    </v-flex>
    <HoraPicker v-model="colaborator_hours.hora_entrada" :label="'Hora Entrada ' + dia" />
    <HoraPicker v-model="colaborator_hours.hora_salida" :label="'Hora Salida ' + dia" />
  </v-layout>
  <v-layout v-else row wrap>
    <v-flex xs12 sm4 md4>
      <v-select
        v-model="colaborator_hours.acceso"
        :label=dia
        :items="tipo_dia_acceso"
        readonly
      />
    </v-flex>
    <v-flex xs12 sm3 md3>
      <v-text-field
        v-model="colaborator_hours.hora_entrada"
        :label="'Hora Entrada ' + dia"
        prepend-icon="access_time"
        readonly
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm3 md3>
      <v-text-field
        v-model="colaborator_hours.hora_salida"
        :label="'Hora Salida ' + dia"
        prepend-icon="access_time"
        readonly
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import HoraPicker from '@/components/hora_picker.vue';

export default {
  name: 'horario_row_colaborador',
  components: { HoraPicker },
  props: {
    value: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
    dia: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      hour: '',
      colaborator_hours: this.value,
      input_rules: this.rules,
      text_required_rules: [
        v => !!v || 'Requerido',
      ],
      tipo_dia_acceso: [
        { text: 'No Permitido', value: 'NO_PERMITIDO' },
        { text: 'Todo El Día', value: 'TODO_EL_DIA' },
        { text: 'Con Horario', value: 'CON_HORARIO' },
      ],
      menu_hora_entrada: false,
      menu_hora_salida: false,
      hora_entrada_disabled: false,
      hora_salida_disabled: false,
    };
  },
  watch: {
    colaborator_hours: {
      deep: true,
      handler() {
        this.$emit('input', this.colaborator_hours);
      },
    },
    'colaborator_hours.acceso': {
      immediate: true,
      handler(val) {
        if (val !== 'CON_HORARIO') {
          this.hora_entrada_disabled = true;
          this.hora_entrada = null;
          this.hora_salida_disabled = true;
          this.hora_salida = null;
          this.input_rules = [];
        } else {
          this.hora_entrada_disabled = false;
          this.hora_entrada = this.colaborator_hours.hora_entrada;
          this.hora_salida_disabled = false;
          this.hora_salida = this.colaborator_hours.hora_salida;
          this.input_rules = this.text_required_rules;
        }
      },
    },
  },
};
</script>

<style scoped>

</style>
